var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaximizeCircle = function SvgMaximizeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.333 2H14v2.667M10 6l4-4M4.667 14H2v-2.667M6 10l-4 4M9.346 1.467A7 7 0 0 0 8 1.333a6.67 6.67 0 0 0-6.534 8M6.653 14.533c.434.087.887.134 1.347.134a6.67 6.67 0 0 0 6.533-8"
  })));
};
export default SvgMaximizeCircle;